import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const commissionGroupSelector = createFeatureSelector<IState>('commissionGroup');
export const getCommissionGroupsSelector = createSelector(commissionGroupSelector, (state: IState) => state); 
export const getCommissionGroupSelector = createSelector(commissionGroupSelector, (state: IState) => state.selectedItem); 
